import { getOptionInput } from './factories';
export type { OptionSharedPropertyStatus } from './factories';

export const getOptionCurrencyPair = getOptionInput('currencyPair');
export const getOptionMarkupCurrency = getOptionInput('markupCurrency');
export const getOptionPremiumDate = getOptionInput('premiumDate');
export const getOptionPremiumDateTenor = getOptionInput('premiumDateTenor');
export const getOptionHedgeType = getOptionInput('hedgeType');
export const getOptionAmountReference = getOptionInput('amountReference');
